import React from 'react'
import {translate} from 'react-i18next'

import {getLoginCase} from 'utils/stringUtils'
import {getConfigValue} from 'theme'
import {ProgressBarView, ProgressBarItem, SeparatorBarItem, BarItem} from './ProgressBarStyles'

const ProgressBar = ({t}) => {
  const loginCase = getLoginCase(window.location.search)
  const showProgressBar = getConfigValue('showProgressBar', {loginCase})

  if (!showProgressBar) {
    return null
  }

  return (
    <ProgressBarView>
      <ProgressBarItem className="active">{t('progress-bar.register')}</ProgressBarItem>
      <SeparatorBarItem>
        <BarItem />
        <BarItem />
        <BarItem />
      </SeparatorBarItem>
      <ProgressBarItem>{t('progress-bar.pay')}</ProgressBarItem>
      <SeparatorBarItem>
        <BarItem />
        <BarItem />
        <BarItem />
      </SeparatorBarItem>
      <ProgressBarItem>{t('progress-bar.confirmation')}</ProgressBarItem>
    </ProgressBarView>
  )
}

export default translate()(ProgressBar)
